import * as React from 'react';
import { isMobile } from 'src/utils/responsiveHelpers';
import './UploadPhotoModal.scss';
import Modal from '../../../common/Modal';

interface IUploadPhotoModalProps {
  onUploadFile: (file: FormData) => void;
  onCloseModal: () => void;
}

interface IUploadPhotoModalState {
  isMobile: boolean;
}

class UploadPhotoModal extends React.Component<
  IUploadPhotoModalProps,
  IUploadPhotoModalState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile()
    };
  }

  private loadFileClick = () => {
    document.getElementById('upload').click();
  };

  private onUploadFile = (e: any) => {
    e.persist();
    const formData = new FormData();
    // debugger;
    formData.append('file', e.target.files[0]);
    this.props.onUploadFile(e.target.files[0]);
    this.props.onCloseModal();
  };

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  private renderForm = () => {
    return (
      <div className="rp-cart-file-modal">
        <span
          onClick={e => this.props.onCloseModal()}
          className="rpds-close rp-cart-file-modal--close-icon"
        />
        <div className="rp-cart-file-modal--instruction-title">
          Please choose a photo to upload from your device:
        </div>
        <button
          className="rp-cart-file-modal--upload-button"
          onClick={e => this.loadFileClick()}
        >
          <span className="rpds-add" />
        </button>
        <input
          id="upload"
          type="file"
          accept="image/x-png,image/gif,image/jpeg"
          onChange={event => {
            this.onUploadFile(event);
          }}
        />
        <div className="rp-cart-file-modal--title">Upload Photo</div>
        {/* <p className="rp-cart-file-modal--paragraph-type">
          You can upload the following file types: .xlsx, .csv, and .txt
        </p>
        <p className="rp-cart-file-modal--paragraph-instruction">
          Or you can download a sample .xlsx template to see an example of the
          format required here:
        </p> */}
      </div>
    );
  };

  public render() {
    return this.state.isMobile ? (
      <div className="rp-cart-file-modal--mobile">
        <div
          onClick={e => this.props.onCloseModal()}
          className="rp-cart-file-modal--mobile-cancel"
        >
          <span className="rpds-close cancel-icon" />
          Cancel
        </div>
        {this.renderForm()}
      </div>
    ) : (
      <Modal handleCloseModal={this.props.onCloseModal}>
        {this.renderForm()}
      </Modal>
    );
  }
}

export default UploadPhotoModal;
